export default ({ label, help, videoProperties, videoPropertiesKey }) => ({
  // this key deliberately doesn't match any actual property name to avoid change tracking
  // since its form field handles cache state on its own, so a save button doesn't make sense.
  replaceVideo: {
    type: 'ReplaceVideo',
    label,
    help,
    videoProperties,
    videoPropertiesKey,
  },
});
